/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  Menu,
  MenuItem,
  PaginationItem,
  IconButton,
  Tab,
  Tabs,
  useTheme,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import comment from 'packages/novous_web/src/assets/icons/CommentBlue.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import menu from 'packages/novous_web/src/assets/icons/menu.svg';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import CheckIcon from 'packages/novous_web/src/assets/icons/checkBlue.svg';
import dayjs from 'dayjs';
import CustomFilterModal from 'packages/novous_web/src/common/components/CustomFilterModal';
import DriverCoachingCommentModal from './DriverCoachingCommentModal';
import AddComment from 'packages/novous_web/src/common/components/AddComment';
import DriverCoachingDataTiles from './DriverCoachingDataTiles';
import { useUtil } from 'packages/novous_web/src/context/utilContext';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import CoachingModal from 'packages/novous_web/src/pages/Dashboard/Alarm/Driver-Coaching/Dashboard/components/ShareCoachingModal';
interface DriverCoachingDataProps {
  alertName: string;
  assignedBy: string;
  coachingSessionId: string;
  coachingStatus: string;
  completedModulesCount: number;
  createdAt: string;
  deviceType: string;
  driverId: string;
  depot: string;
  driverName: string;
  employeeId: string;
  fleetAdminId: string;
  fleetId: string;
  progressPercentage: number;
  warningType: number;
  alertVideoUrls: string[];
  trainingDate: string | null;
  monthlyScore: number;
}

interface CoachingTableData {
  employeeId: string;
  driverName: string;
  coachingStatus: string;
  progressPercentage: number;
  completedModulesCount: number;
  coachingSessionId: string;
  driverId: string;
  alertVideoUrls: string[];
  depot: string;
  latestComment: string;
  trainingDate: string | null;
  monthlyScore: number;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

interface CameraProps {
  cameraId: string;
  cameraName: string;
  playBackUrl: string;
}

interface DriverCoachingDataTableProps {
  handleTile: (data: ColumnObjType) => void;
  fromCoaching?: boolean;

  dateState?: any;
  selectedDriverId?: string;
}
interface FilterField {
  key: string;
  label: string;
  options?: { value: string; label: string }[];
  defaultValue?: string;
  input?: boolean;
}

const DriverCoachingDataTable: React.FC<DriverCoachingDataTableProps> = ({
  handleTile,
  fromCoaching,
  selectedDriverId,
}) => {
  const location = useLocation();
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const { user } = useAuth();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<DriverCoachingDataProps[]>([]);
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [filteredData, setFilteredData] = useState<CoachingTableData[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { selectionDate, setSelectionDate, selectedType, setSelectedType } = useUtil();
  const [selectedTrip, setSelectedTrip] = useState<any>(null);
  const [commentTrip, setCommentTrip] = useState<any>(null);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [filterData, setFilterData] = useState<any>({
    data: {},
    isfiltered: false,
  });
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [activeTab, setActiveTab] = useState<'SYSTEM' | 'USER_TAG'>('SYSTEM');
  const paginatedArr = useRef<any[]>([null]);
  const [currentPage, setCurrentPage] = useState(1);
  let filterFileds: FilterField[] = [];
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    createdAt: { name: 'Date & Time', status: true },
    employeeId: { name: 'Employee ID', status: true },
    driverName: { name: 'Driver Name', status: true },
    depot: { name: 'Depot', status: true },
    alertName: { name: 'Top Alert', status: true },
    monthlyScore: { name: 'Score', status: true },
    trainingDate: { name: 'Training Date', status: true },
    coachingStatus: { name: 'Coaching Status', status: true },
    progressPercentage: { name: 'Learning Progress', status: true },
    completedModulesCount: { name: '#Coaching Completed', status: true },
    actions: { name: 'Actions', status: true },
  });
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Under Coaching', status: true },
    Stat2: { name: 'Coaching Required', status: true },
    Stat3: { name: "Coaching's Completed", status: true },
    Stat4: { name: 'Avg Alerts per Driver', status: true },
  });
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const navigate = useNavigate();
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  //   const { setTripData } = useTripContext();
  // const [openShareModal, setOpenShareModal] = useState(false);
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const handleOpen = () => setIsCustomiseModalOpen(true);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const handleClose = () => setIsCustomiseModalOpen(false);
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const {
    data: downloadCoachingData,
    error: downloadCoachingError,
    loading: downloadCoachingLoading,
    fetchData: fetchDownloadCoachingData,
  } = useApiError<any>(`${API_ENDPOINTS.coaching.DRIVER_COACHING_DOWNLOAD}`, 'POST', 'blob');

  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Monthly', 'Custom Range'];
  const todayStr = dayjs().format('YYYY-MM-DD');

  const [selectedDuration, setSelectedDuration] = useState(dateRangeArr[0]);
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [monthAnchorEl, setMonthAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const viewClickRef = useRef(false);
  const hasInitializedDuration = useRef(false);
  const [startDate, setStartDate] = useState(todayStr);
  const [endDate, setEndDate] = useState(todayStr);

  const monthOptions = useMemo(
    () =>
      Array.from({ length: 12 }, (_, index) => {
        const month = dayjs().subtract(index, 'month');
        return { label: month.format('MMMM YYYY'), value: month.format('YYYY-MM') };
      }),
    [],
  );
  const currentMonthValue = dayjs().format('YYYY-MM');

  const getMonthRange = (monthValue: string) => {
    const start = dayjs(`${monthValue}-01`).format('YYYY-MM-DD');
    const end = dayjs(`${monthValue}-01`).endOf('month').format('YYYY-MM-DD');
    return { startDate: start, endDate: end };
  };

  const getDateRange = (range: string) => {
    const today = dayjs();
    let nextStartDate = '';
    let nextEndDate = '';
    const startTime = '00:00:00';
    const endTime = '23:59:59';

    switch (range) {
      case 'Today':
        nextStartDate = today.format('YYYY-MM-DD');
        nextEndDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        nextStartDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        nextEndDate = nextStartDate;
        break;
      case '7 Days':
        nextStartDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        nextEndDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        nextStartDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        nextEndDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        nextStartDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        nextEndDate = today.format('YYYY-MM-DD');
        break;
      default:
        nextStartDate = '';
        nextEndDate = '';
    }
    return { startDate: nextStartDate, endDate: nextEndDate, startTime, endTime };
  };

  let { startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration);

  if (startDate !== '' && endDate !== '') {
    startDateC = startDate;
    endDateC = endDate;
  } else if (startDate === '' && endDate === '') {
    ({ startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration));
  }

  useEffect(() => {
    return () => {
      if (!viewClickRef.current) {
        setSelectedType(null);
        setSelectionDate({
          startDate: null,
          endDate: null,
        });
      }
    };
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
    setShowDatePicker(false);
  };

  const handleCalendarClose = () => {
    setShowDatePicker(false);
    setCalendarAnchorEl(null);
  };

  const handleMonthClose = (value?: string) => {
    if (value) {
      const { startDate: newStartDate, endDate: newEndDate } = getMonthRange(value);
      setSelectedDuration('Monthly');
      setSelectedType('Monthly');
      setSelectedMonth(value);
      setStartDate(newStartDate);
      setEndDate(newEndDate);
      setSelectionDate({
        startDate: newStartDate,
        endDate: newEndDate,
      });
    }
    setMonthAnchorEl(null);
  };

  const handleClosed = (value?: string) => {
    if (!value) {
      setAnchorEl(null);
      return;
    }

    if (value === 'Monthly') {
      setShowDatePicker(false);
      setMonthAnchorEl(anchorEl);
      setAnchorEl(null);
      return;
    }

    if (value === 'Custom Range') {
      setSelectedType(value);
      setSelectedDuration(value);
      setSelectedMonth('');
      setShowDatePicker(true);
      setCalendarAnchorEl(anchorEl);
      setAnchorEl(null);
      return;
    }

    setSelectedType(value);
    setSelectedDuration(value);
    setSelectedMonth('');
    setShowDatePicker(false);
    setMonthAnchorEl(null);
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setAnchorEl(null);
  };

  interface DriverCoachingResponse {
    data: {
      coachingLists: DriverCoachingDataProps[];
      lastEvaluatedKey: string | null;
    };
  }

  const handleReset = () => {
    setTilesObj({
      Stat1: { name: 'Under Coaching', status: true },
      Stat2: { name: 'Coaching Required', status: true },
      Stat3: { name: "Coaching's Completed", status: true },
      Stat4: { name: 'Avg Alerts per Driver', status: true },
    });
    // your reset logic here
  };

  const {
    data: driverCoachingData,
    error: driverCoachingError,
    loading: driverCoachingLoading,
    fetchData: fetchDriverCoachingData,
  } = useAxios<DriverCoachingResponse>(API_ENDPOINTS.coaching.DRIVER_COACHING_FETCH, 'POST');

  useEffect(() => {
    if (driverCoachingData?.data?.lastEvaluatedKey) {
      if (driverCoachingData?.data?.lastEvaluatedKey) {
        if (paginatedArr.current.length === currentPage) {
          paginatedArr.current.push(driverCoachingData.data.lastEvaluatedKey);
        }
      }
    }
  }, [driverCoachingData]);

  const totalPages = driverCoachingData?.data.lastEvaluatedKey
    ? paginatedArr.current.length + 1
    : paginatedArr.current.length;
  // Handler for changing pages.

  const handlePageChange = async (event: React.ChangeEvent<unknown>, page: number) => {
    const requestParams = {
      fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
      coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
      lastEvaluatedKey: paginatedArr.current[page - 1],
      startDate: startDate,
      endDate: endDate,
      ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
      // Include filter parameters if filtering is active
      ...(filterData.isfiltered && {
        driverId: filterData.data?.driverId,
        coachingStatus: filterData.data?.coachingStatus,
      }),
    };

    if (filterData.isfiltered) {
      await fetchDriverCoachingFilterData(requestParams);
    } else {
      await fetchDriverCoachingData(requestParams);
    }

    setCurrentPage(page);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!startDate || !endDate) return;

      setCurrentPage(1);
      paginatedArr.current = [null];

      try {
        if (filterData.isfiltered) {
          const filterParams = {
            driverId: filterData.data?.driverId || '',
            coachingStatus: filterData.data?.coachingStatus,
            coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
            lastEvaluatedKey: null,
            fleetId: user?.customer_id,
            startDate,
            endDate,
            ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
          };
          await fetchDriverCoachingFilterData(filterParams);
        } else {
          const params = {
            fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
            coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
            lastEvaluatedKey: null,
            startDate,
            endDate,
            ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
          };
          await fetchDriverCoachingData(params);
        }
      } catch (error) {
        console.error('Error fetching driver coaching data:', error);
      }
    };

    fetchData();
  }, [activeTab, startDate, endDate, filterData.isfiltered, filterData.data?.driverId, filterData.data?.coachingStatus]);

  const getLatestComment = (report: any): string => {
    const comments = report?.coachingComments;
    if (!Array.isArray(comments) || comments.length === 0) return '';

    const latestComment = [...comments].sort((a, b) =>
      (b.commentDate || '').localeCompare(a.commentDate || ''),
    )[0];

    return latestComment?.comment || '';
  };

  const processedData = useMemo(() => {
    if (!driverCoachingData?.data?.coachingLists) return [];

    return driverCoachingData.data.coachingLists
      .filter((report) => report) // Remove any undefined/null reports
      .map((report) => ({
        employeeId: report.employeeId || '',
        driverName: report.driverName || '',
        depot: report.depot || '',
        alertName: report.alertName || '',
        monthlyScore: report.monthlyScore ?? 0,
        trainingDate: report.trainingDate || null,
        coachingStatus: report.coachingStatus || '',
        progressPercentage: report.progressPercentage || 0,
        completedModulesCount: report.completedModulesCount || 0,
        coachingSessionId: report.coachingSessionId || '',
        driverId: report.driverId || '',
        alertVideoUrls: report.alertVideoUrls || [],
        createdAt: report.createdAt || '',
        latestComment: getLatestComment(report),
      }));
  }, [driverCoachingData]);

  const {
    data: driverCoachingDriversData,
    error: driverCoachingDriversDataError,
    loading: driverCoachingDriversDataLoading,
    fetchData: fetchDriverCoachingDriversData,
  } = useAxios<{ data: any }>(`${API_ENDPOINTS.alarm.DRIVER_ALERT_BY_DRIVER_OR_VEHICLE}`, 'POST');

  useEffect(() => {
    fetchDriverCoachingDriversData({
      fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
    });
  }, [user]);

  const {
    data: driverCoachingFilterData,
    error: driverCoachingFilterDataError,
    loading: driverCoachingFilterDataLoading,
    fetchData: fetchDriverCoachingFilterData,
  } = useAxios<{ data: any; lastEvaluatedKey: any }>(
    `${API_ENDPOINTS.coaching.DRIVER_COACHING_FILTER}`,
    'POST',
  );

  const processedFilterData = useMemo(() => {
    if (!driverCoachingFilterData?.data?.coachingLists) return [];

    return driverCoachingFilterData.data.coachingLists
      .filter((report: any) => report)
      .map((report: any) => ({
        employeeId: report.employeeId || '',
        driverName: report.driverName || '',
        depot: report.depot || '',
        alertName: report.alertName || '',
        monthlyScore: report.monthlyScore ?? 0,
        trainingDate: report.trainingDate || null,
        coachingStatus: report.coachingStatus || '',
        progressPercentage: report.progressPercentage || 0,
        completedModulesCount: report.completedModulesCount || 0,
        coachingSessionId: report.coachingSessionId || '',
        driverId: report.driverId || '',
        alertVideoUrls: report.alertVideoUrls || [],
        createdAt: report.createdAt || '',
        latestComment: getLatestComment(report),
      }));
  }, [driverCoachingFilterData]);

  const driverNameOptions =
    driverCoachingDriversData?.data?.drivers?.map(
      (driver: { key: string; value: string; employeeId?: string }) => ({
        value: driver.key,
        label: `${driver.value} (${driver.employeeId || ''})`.trim(),
      }),
    ) || [];

  filterFileds = [
    {
      key: 'driverId',
      label: 'Driver Name',
      options: driverNameOptions,
    },
    {
      key: 'coachingStatus',
      label: 'Coaching Status',
      options: [
        { value: 'REQUIRED', label: 'Required' },
        { value: 'PROGRESS', label: 'Progress' },
        { value: 'COMPLETED', label: 'Completed' },
      ],
    },
  ];

  const handleApplyFilters = async (filterValues: any) => {
    if (!filterValues || typeof filterValues !== 'object') {
      return;
    }

    const driverId = filterValues?.driverId || '';
    const coachingStatus = filterValues?.coachingStatus || '';
    setSearchQuery('');
    // const filtered = processedData.filter((item) => {
    //     if (!item || typeof item !== 'object') return false;

    //     const matchesDriverId = driverId ? item.driverId === driverId : true;
    //     const matchesCoachingStatus = coachingStatus ? item.coachingStatus === coachingStatus : true;

    //     return matchesDriverId && matchesCoachingStatus;
    // });

    // setFilteredData(filtered);
    setFilterData({
      data: {
        ...(driverId && { driverId }), // Only include if not empty
        ...(coachingStatus && { coachingStatus }), // Only include if not empty
      },
      isfiltered: driverId !== '' || coachingStatus !== '', // Set to true if either filter has value
    });

    await fetchDriverCoachingFilterData({
      fleetId: user?.customer_id,
      ...(driverId && { driverId }), // Only include in API call if not empty
      ...(coachingStatus && { coachingStatus }), // Only include in API call if not empty
      lastEvaluatedKey: null,
      coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
      ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
    });

    setIsFilterModelOpen(false);
    setCurrentPage(1);
    paginatedArr.current = [null];
  };

  useEffect(() => {
    if (downloadCoachingData) {
      try {
        if (downloadCoachingData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadCoachingData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `driver_coaching_report.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          // Removed console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        // Removed console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadCoachingData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };

  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj, handleTile]);

  const navigateToDriverDetails = (driverData: any) => {
    const params = new URLSearchParams();

    // Add date filters if they exist
    if (startDate && endDate) {
      params.set('startDate', startDate);
      params.set('endDate', endDate);
    }

    if (selectedDuration) {
      params.set('selectedDuration', selectedDuration);
    }

    // Add driver information
    params.set('driverId', driverData.driverId);
    params.set('driverName', driverData.driverName);
    params.set('employeeId', driverData.driverId);
    params.set('fromCoaching', 'true');
    viewClickRef.current = true;
    navigate(`/alarm/driver-alert-dashboard?${params.toString()}`);
  };

  // const handleLiveFeedOpen = (driverId: string, data: any) => {
  //     navigate(`driver-coaching-dashboard/${driverId}`, { state: { data } });
  // }

  const viewMenuData = [
    {
      name: 'Driver Details',
      icon: live,
      click: () => navigateToDriverDetails(selectedTrip),
    },
    {
      name: 'Add Comment / Training Date',
      icon: comment,
      click: () => {
        setCommentTrip(selectedTrip);
        setIsCommentOpen(true);
        handleCloseMenu();
      },
    },
  ];

  useEffect(() => {
    if (!driverCoachingData?.data?.coachingLists) return;
    if (driverCoachingData?.data) {
      const driverListData: DriverCoachingDataProps[] = driverCoachingData?.data?.coachingLists.map(
        (driverCoaching) => ({
          employeeId: driverCoaching.employeeId,
          driverName: driverCoaching.driverName,
          depot: driverCoaching.depot,
          coachingStatus: driverCoaching.coachingStatus,
          progressPercentage: driverCoaching.progressPercentage,
          completedModulesCount: driverCoaching.completedModulesCount,
          coachingSessionId: driverCoaching.coachingSessionId,
          driverId: driverCoaching.driverId,
          alertName: '', // add default values for the required properties
          assignedBy: '',
          createdAt: '',
          deviceType: '',
          fleetAdminId: '',
          fleetId: '',
          warningType: 0,
          alertVideoUrls: [],
          trainingDate: driverCoaching.trainingDate || null,
          monthlyScore: driverCoaching.monthlyScore ?? 0,
        }),
      );
      setData(driverListData);
    }
  }, [driverCoachingData]);

  useEffect(() => {
    if (debouncedSearchQuery) {
      const dataToSearch = filterData.isfiltered ? processedFilterData : processedData;
      const filtered = dataToSearch.filter(
        (coaching: CoachingTableData) =>
          coaching.employeeId?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
          coaching.driverName?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
          coaching.coachingStatus?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
          coaching.progressPercentage?.toString().includes(debouncedSearchQuery) ||
          coaching.latestComment?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(filterData.isfiltered ? processedFilterData : processedData);
    }
  }, [
    debouncedSearchQuery,
    processedData,
    driverCoachingFilterData?.data?.coachingLists,
    filterData.isfiltered,
  ]);

  const [rowMenuAnchorEl, setRowMenuAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, trip: any) => {
    setRowMenuAnchorEl(event.currentTarget);
    setSelectedTrip(trip);
  };

  const handleCloseMenu = () => {
    setRowMenuAnchorEl(null);
  };

  // useEffect(() => {
  //     if (location.state) {
  //         const { startDate, endDate, selectedDuration } = location.state;
  //         if (startDate) setStartDate(startDate);
  //         if (endDate) setEndDate(endDate);
  //         if (selectedDuration) setSelectedDuration(selectedDuration);
  //     }
  // }, [location.state]);

  // useEffect(() => {
  //     const params = new URLSearchParams(location.search);
  //     const startDate = params.get('startDate');
  //     const endDate = params.get('endDate');
  //     const selectedDuration = params.get('selectedDuration');

  //     if (startDate) setStartDate(startDate);
  //     if (endDate) setEndDate(endDate);
  //     if (selectedDuration) setSelectedDuration(selectedDuration);
  // }, [location.search]);

  //   useEffect(() => {
  //     if (location.state?.returnPath === location.pathname) {
  //       setStartDate(location.state.startDate || '');
  //       setEndDate(location.state.endDate || '');
  //       setSelectedDuration(location.state.selectedDuration || dateRangeArr[0]);
  //     }
  //   }, [location.state]);

  const allColumns: MRT_ColumnDef<CoachingTableData>[] = useMemo(
    () => [
      {
        accessorKey: 'createdAt',
        header: 'Date & Time',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue<string>();
          const isoString = rawValue.replace(':', 'T'); // "2025-06-11:16:49:38" -> "2025-06-11T16:49:38"
          const date = new Date(isoString);

          const formattedDate = date.toLocaleString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          });

          // Replace " at " with ", " in case the locale adds that
          const displayDate = formattedDate.replace(' at ', ', ');

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {displayDate}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'employeeId',
        header: 'Employee ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell, row }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            noWrap
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '21px',
              letterSpacing: '0%',
              textDecoration: 'underline',
              textDecorationStyle: 'solid',
              textDecorationOffset: '0%',
              textDecorationThickness: '0%',
              textDecorationSkipInk: 'auto',
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate(`/driver-coaching/${row.original.driverId}`);
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'driverName',
        header: 'Driver Name',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'depot',
        header: 'Depot',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'alertName',
        header: fromCoaching ? 'Event' : 'Top Alerts',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'monthlyScore',
        header: 'Score',
        enableColumnActions: false,
        size: isSmallScreen ? 70 : 100,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>() ?? '-'}
          </Typography>
        ),
      },
      {
        accessorKey: 'trainingDate',
        header: 'Training Date',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 160,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string | null>() || '-'}
          </Typography>
        ),
      },
      {
        accessorKey: 'coachingStatus',
        header: fromCoaching ? 'Status' : 'Coaching Status',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => {
          const status = cell.getValue<string>();

          // Define styles based on status
          let backgroundColor = '';
          let textColor = '';

          if (status === 'REQUIRED') {
            backgroundColor = '#F7E1E1';
            textColor = '#C83333';
          } else if (status === 'PROGRESS') {
            backgroundColor = '#E0ECFD';
            textColor = '#2F80ED';
          } else if (status === 'COMPLETED') {
            backgroundColor = 'rgba(39, 174, 96, 0.15)';
            textColor = 'rgba(33, 150, 83, 1)';
          }

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '8px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" fontWeight={500} style={{ color: textColor }}>
                {status}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'progressPercentage',
        header: fromCoaching ? 'Completion %' : 'Learning Progress',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => {
          const progress = cell.getValue<number>();
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                width: '100%',
              }}
            >
              <div
                style={{
                  flexGrow: 0.5,
                  backgroundColor: '#E0E0E0',
                  borderRadius: '4px',
                  height: '8px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#5547DD',
                    width: `${progress}%`,
                    height: '100%',
                    borderRadius: '4px 0 0 4px',
                  }}
                />
              </div>
              <Typography variant="body2" fontWeight={600} fontSize="18px" style={{ minWidth: '40px' }}>
                {progress}%
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'latestComment',
        header: 'Comments',
        enableColumnActions: false,
        size: isSmallScreen ? 140 : 220,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() || '-'}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <IconButton
              size="small"
              sx={{ color: '#5547DD', p: 0 }}
              onClick={() => {
                // const urlParams = new URLSearchParams(window.location.search);
                // if (urlParams.has('fromCoaching')) {
                viewClickRef.current = true;
                setSelectedType(selectedDuration);

                navigate('/driver-coaching/driver-coaching-playlist-details', {
                  state: row.original,
                });
                // } else {
                //     const params = new URLSearchParams();
                //     console.log("startDate", startDate);
                //     console.log("endDate", endDate);
                //     console.log("selectedDuration", selectedDuration);
                //     if (startDate && endDate) {
                //         params.set("startDate", startDate);
                //         params.set("endDate", endDate);
                //     }
                //     if (selectedDuration) {
                //         params.set("selectedDuration", selectedDuration);
                //     }
                //     params.set('driverId', row.original.driverId);
                //     params.set('driverName', row.original.driverName);
                //     params.set('employeeId', row.original.driverId);
                //     params.set('fromCoaching', 'true');
                //     navigate(
                //         `/alarm/driver-alert-dashboard?${params.toString()}`,
                //     );
                // }
              }}
            >
              <img src={eye} alt="custom action" width={24} height={24} />
            </IconButton>
            {!fromCoaching && (
              <IconButton
                sx={{
                  padding: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  setSelectedType(selectedDuration);

                  if (row.original) {
                    handleOpenMenu(event, row.original);
                  } else {
                    console.error('Row data is undefined');
                  }
                }}
              >
                <img src={menu} alt="menu" width={4} height={16} />
              </IconButton>
            )}
          </Box>
        ),
      },
    ],
    [columnObj, isSmallScreen, startDate, endDate, selectedDuration],
  );
  const tableOptions: MRT_TableOptions<CoachingTableData> = {
    columns: allColumns,
    data: searchQuery ? filteredData : filterData.isfiltered ? processedFilterData : processedData,
    enablePagination: false,
    enableColumnFilters: true,
    enableSorting: false,
    enableGlobalFilter: true,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    initialState: {
      columnPinning: {
        left: ['tripId', 'tripName'], // Fix first two columns to the left
        right: ['actions'], // Fix last column to the right
      },
    },
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
  };

  useEffect(() => {
    // Restore duration only when returning from another page with saved context.
    // Never force "Today" after the user has already chosen a range.
    if (!hasInitializedDuration.current) {
      hasInitializedDuration.current = true;
      if (selectedType === 'Monthly' && selectionDate.startDate && selectionDate.endDate) {
        setSelectedDuration('Monthly');
        setSelectedMonth(dayjs(selectionDate.startDate).format('YYYY-MM'));
        setStartDate(selectionDate.startDate);
        setEndDate(selectionDate.endDate);
      } else if (selectedType && selectedType !== 'Custom Range' && selectedType !== 'Monthly') {
        setSelectedDuration(selectedType);
        const { startDate: restoredStart, endDate: restoredEnd } = getDateRange(selectedType);
        setStartDate(restoredStart);
        setEndDate(restoredEnd);
      } else if (selectedType === 'Custom Range' && selectionDate.startDate && selectionDate.endDate) {
        setSelectedDuration('Custom Range');
        setStartDate(selectionDate.startDate);
        setEndDate(selectionDate.endDate);
      } else {
        setSelectedType(dateRangeArr[0]);
      }
      return;
    }

    if (selectedType === 'Custom Range' && selectionDate.startDate && selectionDate.endDate) {
      setSelectedDuration('Custom Range');
      setStartDate(selectionDate.startDate);
      setEndDate(selectionDate.endDate);
    }
  }, [selectionDate, selectedType]);

  const table = useMaterialReactTable(tableOptions);

  const handleDownload = async () => {
    setIsSendingEmail(true);
    const requestData = {
      fleetId: user?.customer_id,
      fileType: selectedFormat,
      startDate,
      endDate,
    };

    try {
      const response = await fetchDownloadCoachingData(requestData);
      if (
        response?.type === 'text/csv' ||
        response?.type === 'application/pdf' ||
        response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setAlertMessage(`File has been downloaded successfully`);
        setAlertType('success');
        setAlertOpen(true);
        // setSelectedDuration(dateRangeArr[0]);
      } else {
        setAlertMessage(response?.error);
        setAlertType('error');
        setAlertOpen(true);
      }
    } catch (error) {
      console.info('Error sending email:', error);
      setAlertMessage((error as Error).message);
      setAlertType('error');
      setAlertOpen(true);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const {
    data: driverCoachingTilesData,
    error: driverCoachingTilesError,
    loading: driverCoachingTilesLoading,
    fetchData: fetchDriverCoachingTilesData,
  } = useAxios<any>(API_ENDPOINTS.coaching.DRIVER_COACHING_TILES, 'POST');

  useEffect(() => {
    if (!startDate && !endDate) return;
    fetchDriverCoachingTilesData({
      fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
      startDate,
      endDate,
    });
  }, [startDate, endDate]);

  const refreshCoachingTable = async () => {
    if (!startDate || !endDate) return;

    setCurrentPage(1);
    paginatedArr.current = [null];

    try {
      if (filterData.isfiltered) {
        await fetchDriverCoachingFilterData({
          driverId: filterData.data?.driverId || '',
          coachingStatus: filterData.data?.coachingStatus,
          coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
          lastEvaluatedKey: null,
          fleetId: user?.customer_id,
          startDate,
          endDate,
          ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
        });
      } else {
        await fetchDriverCoachingData({
          fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
          coachingTabType: activeTab === 'SYSTEM' ? 'SYSTEM' : 'USER_TAG',
          lastEvaluatedKey: null,
          startDate,
          endDate,
          ...(fromCoaching && selectedDriverId && { driverId: selectedDriverId }),
        });
      }

      await fetchDriverCoachingTilesData({
        fleetId: user?.authorities === 'ROLE_FLEET_MANAGER' ? user?.customer_id : user?.id,
        startDate,
        endDate,
      });
    } catch (error) {
      console.error('Error refreshing driver coaching data:', error);
    }
  };

  return (
    <>
      {!fromCoaching && (
        <div className="flex-1 mb-8">
          <DriverCoachingDataTiles driverCoachingTilesData={driverCoachingTilesData} tilesObj={tilesObj} />
        </div>
      )}
      {!fromCoaching && (
        <>
          <AlertToast
            message={alertMessage}
            type={alertType}
            open={alertOpen}
            onClose={() => setAlertOpen(false)}
          />
          <DownloadData
            isDownloadModalOpen={isDownloadModalOpen}
            handleDownloadModalClose={handleDownloadModalClose}
            selectedFormat={selectedFormat}
            handleFormatChange={handleFormatChange}
            handleDownload={handleDownload}
            modalTitle="Download Trips All Data"
            modalDescription="Please select a file format for your download."
            formatLabel="Format"
            formatExcelLabel="Excel"
            formatCsvLabel="CSV"
            formatPdfLabel="PDF"
            cancelButtonText="Cancel"
            downloadButtonText="Download"
          />
        </>
      )}
      <div className={`flex flex-col gap-4 w-full ${fromCoaching && 'mt-8 block'}`}>
        {/* Search Input */}
        {!fromCoaching && (
          <div className=" w-full flex justify-between  gap-4 sm:flex-row flex-col ">
            <div className="flex gap-2">
              <div className="flex gap-2 items-center">
                <div className="max-w-[400px]">
                  <TextField
                    variant="outlined"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search"
                    sx={(theme) => ({
                      '& .MuiOutlinedInput-root': {
                        borderColor: theme.palette.action.selected,
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                      },
                      '& .MuiInputBase-root': { padding: '0rem 1rem' },
                      '& .MuiOutlinedInput-input': {
                        padding: '0px 12px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                      },
                    })}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={searchIcon} alt="icon" width={16} height={16} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          sx={(theme) => ({
                            height: '48px',
                            maxHeight: '48px',
                            display: 'flex',
                            cursor: 'pointer',
                            alignItems: 'center',
                            borderLeft: `1px solid ${theme.palette.action.selected}`,
                            paddingLeft: '8px',
                          })}
                        >
                          <img
                            src={filterIcon}
                            alt="icon"
                            onClick={() => setIsFilterModelOpen(true)}
                            width={24}
                            height={24}
                          />
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      style: {
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '14px',
                        fontWeight: 500,
                      },
                    }}
                  />
                </div>
                {filterData.isfiltered && (
                  <CustomIconButton
                    text={`Clear Filters (${
                      Object.values(filterData.data).filter((value) => value !== '').length
                    })`}
                    background="transparent"
                    outline={false}
                    textColor="#C83333"
                    onClick={() => {
                      setFilterData({ data: {}, isfiltered: false });
                      setFilteredData([]); // Reset filtered data
                    }}
                  />
                )}
              </div>
              <CustomFilterModal
                open={isFilterModel}
                onClose={() => setIsFilterModelOpen(false)}
                onReset={() => {
                  setFilterData({ data: {}, isfiltered: false });
                  setFilteredData([]);
                }}
                title="Filter Coaching Data"
                filterFields={filterFileds}
                onApply={(values) => {
                  console.log('Filter values from modal:', values);
                  handleApplyFilters(values || {});
                }}
                description="Filter coaching sessions by driver and status."
              />
            </div>
            <div className="flex gap-4 flex-wrap">
              {selectedDuration === 'Custom Range' && (
                <div className="flex items-center">
                  <Box
                    sx={(theme) => ({
                      backgroundColor: theme.palette.selected,
                      borderRadius: '8px',
                      padding: theme.spacing(1),
                    })}
                  >
                    <Typography
                      variant="subtitle2"
                      className="truncate"
                      sx={{ fontWeight: 700, marginRight: 1 }}
                    >
                      <span style={{ color: '#235AF9' }}>
                        {startDateC} - {endDateC}
                      </span>
                    </Typography>
                  </Box>
                </div>
              )}

              <div className="relative">
                <Button
                  onClick={handleClick}
                  variant="outlined"
                  sx={{
                    height: { xs: '28px', sm: '30px', md: '48px' },
                    px: { xs: 1, sm: 2 },
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 700,
                    display: 'inline-flex', // Use inline-flex to allow width to adjust dynamically
                    alignItems: 'center',
                    gap: { xs: 0.5, sm: 1 },
                    borderColor: '#5547dd',
                    backgroundColor: 'white',
                    color: '#5547dd',
                    minWidth: 0, // Ensures the button does not have a minimum width constraint
                    maxWidth: '100%', // Prevents overflow
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src={calendar} alt="Calendar" width={18} height={18} />
                    <Box sx={{ display: 'block', maxWidth: '100%' }}>
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {selectedDuration === 'Monthly' && selectedMonth
                          ? `Monthly · ${dayjs(selectedMonth + '-01').format('MMM YYYY')}`
                          : selectedDuration}
                      </Typography>
                    </Box>
                    <img src={arrow} alt="Arrow" width={18} height={18} />
                  </Box>
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => handleClosed()}
                  PaperProps={{
                    sx: {
                      borderRadius: '8px',
                      top: '10px',
                      boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                    },
                  }}
                >
                  {dateRangeArr.map((label) => (
                    <MenuItem
                      key={label}
                      onClick={() => handleClosed(label)}
                      sx={(theme) => ({
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                          backgroundColor: theme.palette.action.hover,
                        },
                        backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                      })}
                    >
                      <Typography variant="button" textTransform={'none'}>
                        {label}
                      </Typography>
                      {selectedDuration === label && (
                        <img
                          src={CheckIcon}
                          alt="check"
                          width={20}
                          height={20}
                          style={{ marginLeft: '16px' }}
                        />
                      )}
                    </MenuItem>
                  ))}
                </Menu>
                <Menu
                  anchorEl={monthAnchorEl}
                  open={Boolean(monthAnchorEl)}
                  onClose={() => setMonthAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      borderRadius: '8px',
                      top: '10px',
                      boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                    },
                  }}
                >
                  {monthOptions.map((month) => {
                    const isCurrentMonth = month.value === currentMonthValue;
                    return (
                      <MenuItem
                        key={month.value}
                        disabled={isCurrentMonth}
                        onClick={() => {
                          if (!isCurrentMonth) handleMonthClose(month.value);
                        }}
                        sx={(theme) => ({
                          transition: 'all 0.2s ease-in-out',
                          backgroundColor: isCurrentMonth
                            ? '#EEEEEE'
                            : selectedMonth === month.value
                              ? theme.palette.selected
                              : 'transparent',
                          cursor: isCurrentMonth ? 'not-allowed' : 'pointer',
                          pointerEvents: isCurrentMonth ? 'none' : 'auto',
                          opacity: 1,
                          '&.Mui-disabled': {
                            opacity: 1,
                            backgroundColor: '#EEEEEE',
                          },
                          '&:hover': {
                            backgroundColor: isCurrentMonth
                              ? '#EEEEEE'
                              : theme.palette.action.hover,
                          },
                        })}
                      >
                        <Typography
                          variant="button"
                          textTransform={'none'}
                          sx={{
                            color: isCurrentMonth ? '#BDBDBD' : 'text.primary',
                            fontWeight: isCurrentMonth ? 400 : 500,
                          }}
                        >
                          {month.label}
                        </Typography>
                        {selectedMonth === month.value && !isCurrentMonth && (
                          <img
                            src={CheckIcon}
                            alt="check"
                            width={20}
                            height={20}
                            style={{ marginLeft: '16px' }}
                          />
                        )}
                      </MenuItem>
                    );
                  })}
                </Menu>
                <Menu
                  anchorEl={calendarAnchorEl}
                  open={showDatePicker}
                  onClose={handleCalendarClose}
                  slotProps={{
                    paper: {
                      sx: {
                        borderRadius: '8px',
                        top: '10px',
                        padding: '0px',
                        boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                      },
                    },
                  }}
                >
                  <DateRangeFilter
                    onCancel={handleCalendarClose}
                    onApply={(from, to) => {
                      setStartDate(from);
                      setEndDate(to);
                      setSelectedType('Custom Range');
                      setSelectedDuration('Custom Range');
                      setSelectedMonth('');
                      setShowDatePicker(false);
                      setSelectionDate({
                        startDate: from,
                        endDate: to,
                      });
                      setCalendarAnchorEl(null);
                    }}
                    initialFrom={startDate}
                    initialTo={endDate}
                  />
                </Menu>
              </div>
              <CustomIconButton
                icon={<img src={Custom} alt="Custom" width={16} height={16} />}
                text="Customize"
                background="transparent"
                outline={false} // Set to true if you want an outline
                onClick={handleOpen}
              />
              <CustomiseTableModal
                open={isCustomiseModalOpen}
                onClose={handleClose}
                onReset={handleReset}
                title="Customize Your Table"
                description="Select and arrange table columns as you prefer."
                columnObj={columnObj}
                tilesObj={tilesObj}
                setTilesObj={setTilesObj}
                setColumnObj={setColumnObj}
              />
              <CustomIconButton
                icon={<img src={downloadWhiteIcon} alt="downloadIcon" width={16} height={16} />}
                text="Download"
                background="primary"
                outline={true}
                onClick={() => {
                  setIsDownloadModalOpen(true);
                }}
              />
            </div>
          </div>
        )}
        <div style={{ width: fromCoaching ? '100%' : '25%' }}>
          {fromCoaching ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6" fontWeight={600} fontSize={20}>
                Coaching History
              </Typography>
              <div style={{ width: '100%', maxWidth: 900, alignItems: 'center' }}>
                <Tabs
                  value={activeTab}
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={(e, newVal) => setActiveTab(newVal)}
                  sx={{
                    borderRadius: '8px',
                    padding: '4px',
                    backgroundColor: theme.palette.selected,
                    '& .MuiTab-root': {
                      // Applies to all tabs
                      minWidth: 250,
                      whitespace: 'normal',
                      color: 'black !important', // Constant black text
                    },
                  }}
                  TabIndicatorProps={{ style: { display: 'none' } }}
                >
                  <Tab
                    label="System Selected"
                    value="SYSTEM"
                    sx={{
                      ...(activeTab === 'SYSTEM' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                  <Tab
                    label="User Tagged Coachable"
                    value="USER_TAG"
                    sx={{
                      ...(activeTab === 'USER_TAG' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                </Tabs>
              </div>
            </div>
          ) : (
            <Tabs
              value={activeTab}
              onChange={(e, newVal) => setActiveTab(newVal)}
              sx={{
                borderRadius: '8px',
                padding: '4px',
                backgroundColor: theme.palette.selected,
                '& .MuiTab-root': {
                  // Applies to all tabs
                  color: 'black !important', // Constant black text
                },
              }}
              TabIndicatorProps={{ style: { display: 'none' } }}
            >
              <Tab
                label="System Selected"
                value="SYSTEM"
                sx={{
                  ...(activeTab === 'SYSTEM' && {
                    backgroundColor: theme.palette.background.default,
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '8px 16px',
                    boxShadow: '0px 4px 6px #5547DD1A',
                  }),
                }}
              />
              <Tab
                label="User Tagged"
                value="USER_TAG"
                sx={{
                  ...(activeTab === 'USER_TAG' && {
                    backgroundColor: theme.palette.background.default,
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '8px 16px',
                    boxShadow: '0px 4px 6px #5547DD1A',
                  }),
                }}
              />
            </Tabs>
          )}
        </div>
        {/* Data Table */}
        <MaterialReactTable table={table} />

        <Menu anchorEl={rowMenuAnchorEl} open={Boolean(rowMenuAnchorEl)} onClose={handleCloseMenu}>
          {viewMenuData.map((item, index) => (
            <MenuItem key={index} onClick={item.click}>
              <div className="flex gap-2 mt-1">
                <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
                <Typography variant="body2" fontWeight={600}>
                  {item.name}
                </Typography>
              </div>
            </MenuItem>
          ))}
        </Menu>

        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Box>

        <CoachingModal open={isShareModalOpen} onClose={() => setIsShareModalOpen(false)} />
        <DriverCoachingCommentModal
          open={isCommentOpen}
          onClose={() => {
            setIsCommentOpen(false);
            setCommentTrip(null);
          }}
          onSuccess={refreshCoachingTable}
          driverId={commentTrip?.driverId || ''}
          coachingSessionId={commentTrip?.coachingSessionId || ''}
        />
      </div>
    </>
  );
};

export default DriverCoachingDataTable;
